<template>
<div>
    <section class="page-title" style="background-color:#c7eafb;">
    <div class="center">
      <v-layout row wrap>
        <v-flex xs12 sm12 lg8>
        <p class="label-planos">Convênio Plano Odontológico</p>
        <h1 class="the-title">Parceria</h1>   
        <h1 class="the-title" style="font-size:25px;color:#00358d">SINDILOTO-RJ – Sindicato dos Empr. Em Casas Lotericas, Loterias Revend Lotericos, Lja de Jogos Autor E Ljs De  Agenciam. Do Jockey Club do Mun. Rio de Janeiro</h1>
        </v-flex>  
        
        <v-flex xs12 sm12 lg4 style="text-align: right;" v-if="this.$vuetify.breakpoint.lg">  
            <br>
            <br>
            <br>
             <img src="../Content/images/Sindiloto.png" width="220px">
        </v-flex>
        <v-flex xs12 sm12 lg4 style="text-align: center;" v-else>  
             <img src="../Content/images/Sindiloto.png" width="220px">
        </v-flex>
        <v-flex xs12 sm6 md6 lg6>
            <br>
            <v-btn
            style="border-radius: 6px;"
            large                
            dark
            @click="openDialog()"
            color="#00358d"
            >Contrate já o plano
            </v-btn>
        </v-flex>       
        </v-layout>
    </div>
</section>

<section class="page-content center">
    <v-layout row wrap>    
    <v-flex xs12 sm12 lg11>
    <img v-if="this.$vuetify.breakpoint.lg" src="../Content/images/precoSinecom.png" style="position: absolute;left: 90%;" width="150px">
    <img v-else src="../Content/images/precoSinecom.png" width="150px">
    <p class="title-label">O seu sorriso é o nosso diferencial</p>
    <p>Informamos que já está em vigor A CONVENÇÃO COLETIVA DE TRABALHO 2020/2021 registrada junto ao Ministério do Trabalho e Emprego.</p>
    <p>CONSIDERANDO que a cláusula 16 da Convenção Coletiva de Trabalho 2020/2021, prevê que as empresas deverão fornecer Plano Odontológico para todos os seus empregados  </p>
    <p>"O SINDILOTO e o SINCOERJ, através do Programa do beneficio Odontológico, acordam que para viabilizar o pagamento de benefícios previsto no programa, os empregadores deverão efetuar o pagamento do valor de R$ 25,00 (vinte e cinco reais) por empregado, sendo vedado qualquer desconto do referido funcionário, motivo pelo qual não há necessidade da anuência do trabalhador, a partir de outubro de 2020, com total responsabilidade do SINDILOTO na contratação do plano odontológico e sua administração, que deverá abranger a o todos os funcionários e empregados nas empresas lotéricas."</p>
    <p>O custo do plano será de R$ 25,00 (vinte e cinco reais), sendo 100% custeado pelo empregador.</p>
    <p>Os empregados que queiram incluir os seus dependentes de¥erão comunicar por escrito a seu empregador, ficando o empregado titular responsável pelo pagamento das mensalidades dos dependentes, por intermédio do desconto em folha de pagamento.</p>
    <ul>Os Valores do plano contratado serão:</ul>
    <li style="font-weight: bold;">Funcionário (adesão obrigatória): R$ 25,00.</li>
    <li style="font-weight: bold;">Dependente (inclusão voluntária): R$25,00, com o valor integral descontado em folha.</li>
    <br>
    <p style="font-weight: bold; font-size: 20px; color:#009b9b">Aproveite já a oportunidade e garanta o sorriso dos seus colaboradores com a PrimaVida Dental.</p>

    </v-flex>


    <v-flex xs12 sm12 lg7>
    <p class="title-label">Acesso à rede credenciada</p>
    <p>Para acessar a rede credenciada, <a href="http://www.primavida.com.br/redecredenciada" target="_blank">clique aqui.</a></p>
    </v-flex>

    <v-flex xs12 sm12 lg6>
    <p class="title-label">Quem pode aderir ao Plano?</p>
    <ul>Dependentes:</ul>
    <li>Pai / Padrasto</li>
    <li>Mãe / Madrasta</li>
    <li>Filhos / Enteados</li>
    <li>Cônjuge / Companheiro</li>
    <br>
    </v-flex>

    <v-flex xs12 sm12 lg6>
    <p class="title-label">Principais Vantagens</p>
    <li>Liberação on-line do seu plano de tratamento;</li>
    <li>O Beneficiário pode incluir familiares e agregados;</li>
    <li>Acesso a rede credenciada através do site www.primavida.com.br;</li>
    <li>Possibilidade de credenciamento de Dentistas por indicação do Associado;</li>
    <li>Desconto em medicamentos nas farmácias &nbsp;<img src="../Content/images/raia.jpg" width="60px"> &nbsp; <img src="../Content/images/drogasil.jpg" width="110px"></li>
    <li>Central de Atendimento exclusiva por Whatsapp;</li>
    <li>Aplicativo para Celular / Tablet com rede Credenciada;</li>
    <li>Carteirinha Virtual;</li>
    <li>Boleto Virtual;</li>
    <br>
    </v-flex>
    
    <v-flex xs12 sm12 lg12>
    <br>
    <p class="title-label">App PrimaVida Beneficiário</p>    
    </v-flex>
    <v-flex xs5 sm5 lg2>
    <img src="../Content/images/app_android.png" width="120px"><br>
    <a href="https://play.google.com/store/apps/details?id=br.com.primavida.associado" target="_blank"><img src="../Content/images/android.png" width="120px"></a>&nbsp;
    </v-flex>
    <v-flex xs5 sm5 lg2>
    <img src="../Content/images/app_apple.png" width="120px"><br>
    <a href="https://apps.apple.com/br/app/primavida-dental-associado/id1464690839" target="_blank"><img src="../Content/images/apple_stote.png" width="120px" ></a>&nbsp;
    </v-flex>
    <v-flex xs5 sm5 lg5>
    <img src="../Content/images/app_whats.png" width="120px"><br>
    <a href="https://api.whatsapp.com/send?phone=5521971640379" target="_blank"><img src="../Content/images/whatsapp.png" width="120px" ></a>&nbsp;
    </v-flex>
    
    </v-layout>
    <br>
    <p class="title-label">Principais Coberturas (Rol da ANS)</p>
    <p>Smile Emp BH - Reg ANS nº 475862165</p>
    <div class="icone consultas">
        <span class="icon"></span>
        <p><strong>Consultas</strong> - Consultas iniciais para o plano de tratamento;</p>
    </div>
    <div class="icone urgencia">
        <span class="icon"></span>
        <p><strong>Urgência</strong> - Diversos procedimentos de urgência odontológica;</p>
    </div>
    <div class="icone cirurgia">
        <span class="icon"></span>
        <p><strong>Cirurgia</strong> - Cirurgias odontológicas de pequeno porte realizada em consultórios;</p>
    </div>
    <div class="icone dentistica">
        <span class="icon"></span>
        <p><strong>Dentística</strong> - Restaurações e obturações em material estético (Resina) e amálgama;</p>
    </div>
    <div class="icone endodontia">
        <span class="icon"></span>
        <p><strong>Endodontia</strong> - Tratamento de canais;</p>
    </div>
    <div class="icone periodontia">
        <span class="icon"></span>
        <p><strong>Periodontia</strong> - Tratamento de gengivas;</p>
    </div>
    <div class="icone odontopediatria">
        <span class="icon"></span>
        <p><strong>Odontopediatria</strong> - Atendimento especializado para crianças;</p>
    </div>
    <div class="icone radiologia">
        <span class="icon"></span>
        <p><strong>Raio X</strong> - Periapical, interproximal (bite-wing), oclusal, periapical completa (levantamento radiográfico);</p>
    </div>
    <div class="icone protese">
        <span class="icon"></span>
        <p><strong>Próteses</strong> - Coroa provisória, Restauração, Coroa, Núcleo e Bloco metálico para dentes permanentes posteriores, Coroa em Cerômero para dentes permanentes anteriores (Entende-se como dentes permanentes anteriores, os dentes definitivos da frente, que correspondem do canino a canino);</p>
    </div>
    <div class="icone profilaxia">
        <span class="icon"></span>
        <p><strong>Prevenção</strong> - Profilaxia / Aplicação de Flúor;</p>
    </div>
    <div class="icone exodontia">
        <span class="icon"></span>
        <p><strong>Exodontia</strong> - Extração, inclusive de siso incluso;</p>
    </div>
    <div>
        <p>Para acessar a cobertura do Rol da ANS, <a href="http://www.primavida.com.br/emkt/rol_procedimentos.pdf" target="_blank">clique aqui.</a></p>
    </div>
    <v-flex xs12 sm6 md6 lg6 >
        <v-btn
        style="border-radius: 6px;"
        large                
        dark
        @click="openDialog()"
        color="#00358d"
        >Contrate já o plano</v-btn>
    </v-flex>
</section>
<v-dialog v-model="dialog" max-width="700px" max-height="400px" > 
      <v-card>
          <v-container grid-list-md>
            <v-layout row wrap justify-center>
              <v-card-title>
              <span class="total">Prezado(a) parceiro(a),</span>              
              </v-card-title>
              <v-container                    
                    fluid
                    pa-1
                    justify-center
                    class="resumo"
                  >
              <p class="resumo" >Valorizamos a privacidade de seus dados. Por isso, investimos em modernidade nos nossos canais de comunicação, garantindo assim a  segurança e a tranquilidade que você precisa.</p>
              <p class="resumo" >Por esse motivo, estamos enviando um termo de privacidade sobre os seus dados cadastrais.</p>
              <p class="resumo" >É necessário que você acesse nossa política de privacidade e aceite os termos para continuarmos recebendo e enviando suas informações.</p>
              <br>
              <p class="resumo" style="font-weight: bold">A <span style="color:#009B99">PrimaVida Dental</span> agradece a sua atenção !</p>
              <p class="resumo" style="font-weight: bold">Vindo de você, tudo é importante!!!</p>
              <br>
              <p class="resumo" style="font-weight: bold;color:#009B99">Termo de Privacidade, <a href="https://ecommerce.primavida.com.br/contratos/Politica_de_Privacidade_PrimaVida_LGPD.pdf" target="_blank">clique aqui.</a></p>
              
              <v-checkbox
                    v-model="contrataccept"
                    color="#009B99"
                >
                <span slot="label">Estou ciente e concordo com o Termo de Privacidade da PrimaVida Dental.</span>
          </v-checkbox>
              </v-container>
            </v-layout>
            <v-card-actions>
              <v-container
                    fill-height
                    fluid
                    pa-1
                    justify-center
                  >
                  <br>
              <v-btn :disabled="!contrataccept" color="#009b9b" depressed style="border-radius: 8px; width: 130px;color: white;" :href="'https://ecommerce.primavida.com.br/contratopj?plano=5f93308a7022267452bdc056'">Continuar</v-btn>
              </v-container>
            </v-card-actions>
          </v-container>
      </v-card>
    </v-dialog>
<Snackbar ref=chamaSnackbar />
</div>
</template>
<script>
import Snackbar from '../components/snackbar.vue'
export default {
    components: {Snackbar},
     data(){
        return{   
                contrataccept: false,
                dialog: false,
                matricula: '',
                dictionary: {          
                custom: {               
                carteirinha: {
                  required: () => 'Informe o número da carteirinha'
                } 
                }
                }
        }               
    },

    mounted : function(){
        this.$store.dispatch('EscondeToolbar')
        this.$store.dispatch('EscondeFooter')
        this.$validator.localize('pt', this.dictionary)
        localStorage.clear()
        sessionStorage.clear()

    },
     watch: {
        dialog(val) {
        val || this.close()
      }
     },
    methods: {
        openDialog(){
            this.dialog = true
        }
        
    }

}
</script>

<style>

    .link{
        font-size: 1.3rem;
        color: #194383;
        text-align: center;
    }
    .titulo{
        font-size: 2rem;
        color: #797a7a;
        text-align: center;
    }
    .tabela{
        border-collapse: separate;
        border-spacing: 2;
    }
</style>